<app-uni-page [parent]="this" pageTitle="Administration: Notification Templates" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full">
    <!-- Toolbar -->
    <div class="flex items-center gap-4 mx-4 my-3">
      <p-floatlabel variant="in">
        <p-select
          [options]="templateTypes"
          [(ngModel)]="templateType"
          (ngModelChange)="onTemplateTypeChange()"
          optionLabel="name"
          inputId="templateType"
          [style]="{ minWidth: '160px' }"
        ></p-select>
        <label for="templateType">Template Type</label>
      </p-floatlabel>

      <button
        pButton
        type="button"
        class="p-button-raised p-button-sm"
        icon="pi pi-plus"
        [disabled]="!canAdd()"
        (click)="onAdd()"
      >
        <span>Add Template</span>
      </button>
      <button
        pButton
        type="button"
        class="p-button-raised p-button-sm"
        icon="pi pi-copy"
        [disabled]="!canCopy()"
        (click)="onCopy()"
      >
        <span>Copy Template</span>
      </button>
      <p-fileUpload
        *ngIf="isAccountAdmin"
        mode="basic"
        name="uploadTemplates"
        chooseIcon="pi pi-upload"
        accept="application/json"
        [maxFileSize]="1000000"
        (uploadHandler)="uploadHander($event)"
        [auto]="true"
        [customUpload]="true"
        chooseLabel="Upload Templates"
        class="p-button p-button-sm"
      />
      <button
        *ngIf="isAccountAdmin"
        pButton
        type="button"
        class="p-button-raised p-button-sm"
        icon="pi pi-download"
        [disabled]="!hasSelectedRows()"
        (click)="downloadSelected()"
      >
        <span>Download Selected</span>
      </button>
    </div>

    <!-- Grid -->
    <app-ag-grid *ngIf="isPageReady" [gridOptions]="gridOptions" [rowData]="templates" class="flex-1 min-h-0"></app-ag-grid>
  </div>
  <p-confirmDialog></p-confirmDialog>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>